import { MicrosoftCloudSettingsSections } from '../../../../../modules/flyOutOnboarding/types'

export const clientSecretExpirationDateField = {
  title: 'Client secret expiration date',
  humanReadableKey: 'Client secret expiration date',
  placeHolder: 'Client secret expiration date',
  id: `${MicrosoftCloudSettingsSections.CLOUD_CREDENTIALS}.clientSecretExpirationDate`,
  isRequired: true,
  isCustom: false,
  dataType: 'date',
  minDate: 'today',
}

export const CLIENT_SECRET_EXPIRED_ERROR_MESSAGE = 'Secret token has expired'
